import React from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';

const CancelComplete: React.FC = () => {
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="キャンセル申込完了" content="キャンセル申込が完了しました。"  />
      </Layout>
    </React.Fragment>
  )
}

export default CancelComplete;